import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Custom = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" data-test="icon-custom" {...props}>
    <path
      d="M3.5625 20.4375V3.5625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5625 18.2198L5.928 17.4923C6.90788 17.1906 7.94086 17.1015 8.95794 17.2308C9.97502 17.3601 10.9528 17.705 11.826 18.2423C12.6785 18.7668 13.6307 19.108 14.6223 19.2444C15.6138 19.3807 16.6229 19.3092 17.5853 19.0343L19.8255 18.3946C20.0018 18.3441 20.1568 18.2376 20.2673 18.0912C20.3777 17.9448 20.4374 17.7664 20.4375 17.5831V5.72781C20.4374 5.59725 20.407 5.4685 20.3487 5.35166C20.2904 5.23483 20.2059 5.1331 20.1017 5.05447C19.9974 4.97583 19.8764 4.92243 19.7481 4.89846C19.6197 4.87448 19.4876 4.88059 19.362 4.91631L17.5853 5.42406C16.6229 5.69894 15.6138 5.77048 14.6223 5.63413C13.6307 5.49777 12.6785 5.15651 11.826 4.63206C10.9528 4.09474 9.97502 3.7499 8.95794 3.62056C7.94086 3.49123 6.90788 3.58038 5.928 3.88206L3.5625 4.60881"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3974 8.30329L13.3342 10.308H14.9294C15.0173 10.3059 15.1037 10.3303 15.1774 10.3781C15.2511 10.4258 15.3087 10.4947 15.3427 10.5757C15.3766 10.6567 15.3854 10.7461 15.3677 10.8322C15.35 10.9182 15.3068 10.9969 15.2437 11.058L13.7789 12.3383L14.5904 14.202C14.6262 14.2874 14.6343 14.3818 14.6135 14.472C14.5927 14.5622 14.5441 14.6436 14.4746 14.7047C14.405 14.7657 14.3181 14.8034 14.226 14.8124C14.1338 14.8214 14.0412 14.8013 13.9612 14.7548L11.9999 13.65L10.0387 14.7518C9.95866 14.7983 9.86605 14.8184 9.77394 14.8094C9.68183 14.8004 9.59487 14.7627 9.52533 14.7017C9.4558 14.6406 9.40721 14.5592 9.38641 14.469C9.36562 14.3788 9.37368 14.2844 9.40945 14.199L10.2209 12.3353L8.7562 11.055C8.69308 10.9939 8.64987 10.9152 8.63221 10.8292C8.61454 10.7431 8.62326 10.6537 8.6572 10.5727C8.69115 10.4917 8.74875 10.4228 8.82248 10.3751C8.89621 10.3273 8.98263 10.3029 9.07045 10.305H10.6657L11.6017 8.30029C11.6402 8.22806 11.6977 8.1677 11.768 8.12572C11.8382 8.08373 11.9186 8.06171 12.0005 8.06201C12.0823 8.06232 12.1626 8.08495 12.2325 8.12747C12.3025 8.16998 12.3595 8.23077 12.3974 8.30329V8.30329Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
